import { useState } from "react";

export default function DevToggle(){
    const [isChecked, setIsChecked] = useState(false);

    const handleToggle = () => {
        setIsChecked( (prev) => !prev );
    };

    if ( isChecked ) {
        document.body.classList.add("show-border");
    } else {
        document.body.classList.remove("show-border");
    }
    
    return(
        <div>
            <label className = "switch2">
                <input type = "checkbox" checked = { isChecked } onChange = { handleToggle }/>
                <span className = "slider2">
                    <span className = "material-symbols-outlined icon">code</span>
                </span>
            </label>
        </div>
    )
}